import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 text-xl font-bold font-heading text-background-50 mb-4 cursor-pointer">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-sm font-bold">OM</span>
              欧美一区
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              汇聚海量优质欧美影视、音乐与文化内容，为您提供最全面的欧美一区资源导航与推荐服务。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">内容分类</h4>
            <div className="flex flex-col gap-2">
              {categories.map((cat) => (
                <Link key={cat.slug} to={`/category/${cat.slug}`} className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">快速链接</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">首页</Link>
              <Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">关于我们</Link>
              <Link to="/category/movies-tv" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">欧美影视</Link>
              <Link to="/category/music" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">欧美音乐</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">联系我们</h4>
            <p className="text-sm text-background-400 leading-relaxed">
              邮箱：contact@oumei1.com<br />
              电话：+86 400-123-4567<br />
              地址：北京市朝阳区建国路88号
            </p>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">© 2024 欧美一区 版权所有 | 精选欧美影视、音乐与文化内容导航平台</p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-500 hover:text-background-300 transition-colors cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-background-500 hover:text-background-300 transition-colors cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-background-500 hover:text-background-300 transition-colors cursor-pointer" aria-label="B站">
              <i className="ri-bilibili-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}